import React, {useState, useEffect, useContext} from 'react';
import axios from 'axios';
import { Row,  Table } from 'reactstrap';

import { useNavigate } from 'react-router-dom';
import { BiEditAlt, BiTrash } from 'react-icons/bi';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom'
import { BiLeftArrowAlt } from 'react-icons/bi';
import useAuth from '../../hooks/useAuth';

const AboutView = () => {
    const { auth } = useAuth();

    const [modal, openModal] = useState(false);
    const toggle = () => openModal(!modal);
    const [about, setAbout] = useState([]);
    const navigate = useNavigate();

    // const {about} = useContext(ContactContext);
    const handleDelete =  async (event, id) => {
        event.preventDefault();
        try {
            const res = await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/abouts/delete-about/${id}`,  {
                headers: {
                    'Authorization': 'Bearer ' + auth.accessToken
                }
            });
            const res1 = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/abouts/find-all`);
            setAbout(res1.data);
            toast.success(res.data.message, {
                className: "success-toast",
                autoClose: 3000,
                position: toast.POSITION.BOTTOM_RIGHT
            })
        } catch (error) {
            error.response.data.message ? toast.error(error.response.data.message, {
                className: "error-toast",
                position: toast.POSITION.BOTTOM_RIGHT,
                autoClose: 3000
                }) :  toast.error(error.response.data.error, {
                  className: "error-toast",
                  position: toast.POSITION.BOTTOM_RIGHT,
                  autoClose: 3000
              })
         }
    }
        
   
    useEffect(() => {
      const source = axios.CancelToken.source();
      const getabout = async () => {
      try {
          const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/abouts/find-all`, {
              cancelToken: source.token
          });
          setAbout(res.data);
         
      } catch (error) {
              if (axios.isCancel(error)) {
                  console.log('cancelled');
              } else {
                  throw error;
              }
          }
      }
      
      getabout();
      return () => {
          source.cancel();
      };
  },[])
    return (
        <div className="container">
          <Row sm="12">
            <h5 className="sec-header">About List</h5>
        </Row> 
        <Row>
            <Table responsive hover>
                <thead>
                <tr>
                    <th>#</th>
                    <th>Tagline</th>
                    <th>Description</th>
                    <th>Image</th>
                    <th>Actions</th>
                </tr>
                </thead>
                <tbody>
                {
                    about.map(about => (
                      <tr key={about.id}>
                        {/* <aboutList about={about} /> */}
                            <td>{about.id}</td>
                            <td style={{wordBreak: "break-all"}}>{about.aboutTagLine}</td>
                            <td style={{wordBreak: "break-all"}} dangerouslySetInnerHTML={{ __html: about.aboutDesc.substring(0, 150)}}></td>
                            <td><img style={{width: 120}} src={process.env.REACT_APP_API_IMAGE_URI.substring(0, process.env.REACT_APP_API_IMAGE_URI.indexOf("/api")) 
                            + `${about.aboutImg.substring(about.aboutImg.indexOf("/uploads"))}`} alt="about-img"></img></td>
                            <td>
                                <BiEditAlt className="edit_icon icon_hover" onClick={() => navigate(`/about/edit/${about.id}`)} size={28}/> 
                                {/* <BiTrash className="delete_icon icon_hover" onClick={(event) => handleDelete(event, about.id)} size={20} />      */}
                            </td>
                    </tr>
                  ))  
                }
                                
                </tbody>
            </Table>
     </Row>
     {/* {
        about && <Row sm="12" className="mt-4 text-center">
          <Link to={"/about/add"} className="go_back" >
            <BiLeftArrowAlt size={30} /> Go to Add about
          </Link>
      </Row> 
         } */}
        </div>
    )
   
}

export default AboutView;